import { Colors } from '../../../../shared/theme/';
import fonts from '../../../../shared/theme/fonts';
import metrics from '../../../../shared/theme/metrics';

export default {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  } as React.CSSProperties,
  formWrapper: {
    backgroundColor: Colors.white,
    padding: '40px',
    borderRadius: '5px'
  } as React.CSSProperties,
  qaDescBox: {
    paddingBottom: metrics.baseMargin + 4,
    paddingTop: metrics.baseMargin + 4
  },
  qaDesc: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
  }
};
